export default "__VITE_ASSET__nXKDywva__"